import emma from '@/common/services/Emma'

const UniversignResource = {
	signPersonalEstate (id) { return emma.get('api/universign/signature-request/personal-estate/' + id) },
	signMissionLetter (id) { return emma.get('api/universign/signature-request/mission-letter/' + id) },
	signMissionReport (id) { return emma.get('api/universign/signature-request/mission-report/' + id) },
	signSubscriptionContract (id) { return emma.get('api/universign/signature-request/subscription-contract/' + id) },
	verify (id) { return emma.get('api/universign/transaction-info/' + id) },
	relaunchTransaction (id) { return emma.get('api/universign/relaunch-transaction/' + id) }
}

export default UniversignResource



// WEBPACK FOOTER //
// ./src/common/resources/Universign.js